import { Form, Input, Radio } from "antd";
import { Rule } from "antd/es/form";

type formItemProp = {
  label: string;
  name?: string;
  rules?: Rule[];
  type: string;
  value?: string;
  onChange?: (e: any) => void;
  readOnly?: boolean;
  disabled?: boolean; 
  children?: React.ReactNode;
  style?: React.CSSProperties;
  addonAfter?: React.ReactNode; 
};

const FormItemInput = ({ label, name, rules, type, value, onChange, readOnly, disabled, children, style, addonAfter }: formItemProp) => {
  return (
    <Form.Item label={label} name={name} rules={rules} initialValue={value}>
      {children || (type === "radio" ? (
        <Radio.Group onChange={onChange} value={value}>
          <Radio value={"male"}>Male</Radio>
          <Radio value={"female"}>Female</Radio>
        </Radio.Group>
      ) : type === "textarea" ? (
        <Input.TextArea 
          value={value} 
          onChange={onChange} 
          readOnly={readOnly} 
          disabled={disabled} 
          style={style} 
        />
      ) : (
        <Input 
          type={type} 
          value={value} 
          onChange={onChange} 
          readOnly={readOnly} 
          disabled={disabled}
          style={style}
          addonAfter={addonAfter}
        />
      ))}
    </Form.Item>
  );
};

export default FormItemInput;
